import('./bootstrap').catch(err => console.error(err));
import posthog from 'posthog-js';

posthog.init(
  'phc_ra82WqMa0GclONhABbLS5sRPw9KZxAqtY9XCt3clkeM',
  {
    api_host:'https://us.i.posthog.com',
    person_profiles: 'identified_only'
  }
)
